import { PublicVideo, PublicVideoCards, } from '@wix/wix-vod-api-site-based/public';
import { toError } from '../../parsers/to-error';
import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
import { parseCards } from '@wix/wix-vod-shared/common';
export class PublicVideoApiService {
    constructor(httpClient, baseUrl) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.getVideoUrls = async (videoId, channelId, instance) => {
            let response;
            try {
                response = await this.siteBasedPublicVideoService.getVideoUrls(videoId, channelId, instance);
            }
            catch (err) {
                return toError(err);
            }
            return response.data;
        };
        this.getDownloadUrl = async (videoId, channelId, instance) => {
            var _a;
            return PublicVideo.getDownloadUrl((_a = this.baseUrl) !== null && _a !== void 0 ? _a : PRODUCTION_HOSTS.catalog, videoId, channelId, instance);
        };
        this.getVideoCardsList = async (channelId, videoId) => {
            let response;
            try {
                response = await this.siteBasedPublicVideoCardsService.getList(channelId, videoId);
            }
            catch (err) {
                return toError(err);
            }
            return parseCards(response.data);
        };
        this.siteBasedPublicVideoService = new PublicVideo(httpClient, baseUrl);
        this.siteBasedPublicVideoCardsService = new PublicVideoCards(httpClient, baseUrl);
    }
}
//# sourceMappingURL=video.js.map